import View from './view.js'
import { useOnValidateSubmit } from './helpers.js'

export default function Logic(props) {
  let onValidateSubmit = useOnValidateSubmit(props)

  return <View {...props} onValidateSubmit={onValidateSubmit} />
}
